<template>
    <div>
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">{{ $t("christmas-gift07") }}</span>
            </li>
        </ul>
        <main>
            <section class="slogan">
                <h1 class="main-title">{{ $t("christmas-gift05") }}</h1>
                <div class="main-subtitle">{{ $t("christmas-gift06") }}</div>
                <nuxt-link v-if="isLogged" :to="localePath('/christmas-gifts')" :class="$i18n.locale.toLowerCase() === 'de' ? 'gifts-btn-de' : 'gifts-btn'">{{ $t("christmas-gift04") }}</nuxt-link>
                <nuxt-link v-else :to="localePath('/register')" :class="$i18n.locale.toLowerCase() === 'de' ? 'gifts-btn-de' : 'gifts-btn'">{{ $t("christmas-gift04") }}</nuxt-link>
            </section>

            <section id="more-collections">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t("christmas-gift07") }}</h2>
                    <div class="title-border"></div>

                    <div class="christmas-wrapper">
                        <div class="christmas-title">{{ $t("christmas-gift08") }}</div>
                        <div class="christmas-bullets">
                            <div class="christmas-bullets-item christmas-bullets-item1"><div class="row-icon"></div>{{ $t("christmas-gift09") }}</div>
                            <div class="christmas-bullets-item christmas-bullets-item2"><div class="row-icon"></div>{{ $t("christmas-gift10") }}</div>
                            <div class="christmas-bullets-item christmas-bullets-item3"><div class="row-icon"></div>{{ $t("christmas-gift11") }}</div>
                        </div>
                    </div>

                    <HomeMoreCollections class="home-more-collections" :christmas="true" :useSlider="true" :collections-list="restCollectionsItems"></HomeMoreCollections>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeMoreCollections from "../components/home/HomeMoreCollections";
import {GOrders, GUser} from "@/store/getters";
import {AOrders} from "@/store/actions";

export default {
    name: 'collections',
    head: {
        title: 'Fine Wine Collections | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'collections-page christmas-page'
        }
    },
    components: {
        HomeMoreCollections
    },
    data(){
        return {
            collectionItems: [],
            restCollectionsItems: []
        }
    },
    computed: {
        ...mapGetters({
            collectionsList: GOrders.GET_COLLECTIONS,
            isLogged: GUser.GET_USER_LOGGED,
            collectionsListLength: GOrders.GET_COLLECTIONS_LENGTH
        })
    },
    methods: {
        getCollectionItems() {
            this.$store.dispatch(AOrders.GET_COLLECTIONS, this.$i18n.locale).then(() => {
                this.collectionItems = this.collectionsList;
                this.restCollectionsItems = this.collectionItems.filter(el => el.isGiftDelivery);
            });
        }
    },
    mounted() {
        this.getCollectionItems();

        this.$nuxt.$on('langUpdated', () => {
            this.getCollectionItems();
        })
    }
};
</script>

<style scoped>
.gifts-btn {
    display: flex;
    padding: 8px 16px;
    align-items: flex-start;
    gap: 8px;
    width: 165px;
    height: 36px;
    border-radius: 8px;
    background: white;
    color: #004F7F;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    text-decoration: none;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    justify-content: center;
    bottom: 40px;
}
.gifts-btn-de {
    display: flex;
    padding: 8px 16px;
    align-items: flex-start;
    gap: 8px;
    width: 245px;
    height: 36px;
    border-radius: 8px;
    background: white;
    color: #004F7F;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    text-decoration: none;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 40px;
    text-align: center;
}
.home ul {
    padding-left: 0;
}
.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.padding200 {
    padding: 0 200px;
}
.padding80 {
    padding-top: 80px;
    padding-bottom: 80px;
}
.title-border {
    width: 64px;
    height: 4px;
    background: #ECD9A7;
    margin: 24px auto 16px;
}

.slogan {
    height: 458px;
    position: relative;
    background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0.00) 32.64%), url('../assets/gifts/hero.jpg') no-repeat center top;
    background-size: cover;
}

.main-title {
    color: #ffffff;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
    padding: 40px 0 24px 0;
    text-transform: capitalize;
    text-align: center;
    margin-bottom: 0;
}
html[lang=de] .main-title {
    text-transform: none;
}
.main-subtitle {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    text-align: center;
    color: #FFFFFF;
    max-width: 918px;
    margin: 0 auto;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
.christmas-wrapper {
    border-radius: 8px;
    background: url('../assets/gifts/banner.jpg') no-repeat center;
    background-size: cover;
    box-shadow: 0 4px 16px 0 rgba(117, 102, 62, 0.50);
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
    height: 176px;
    margin: 40px 0;
}
.christmas-title {
    color: white;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    height: 20px;
    align-self: stretch;
}
.christmas-bullets {
    display: flex;
    align-items: flex-start;
    align-self: stretch;
}
.christmas-bullets-item {
    display: flex;
    gap: 8px;
    flex: 1 0 0;
    color: white;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    flex-direction: column;
    align-items: center;
}
.christmas-bullets-item .row-icon {
    height: 56px;
    width: 56px;
}
.christmas-bullets-item1, .christmas-bullets-item2 {
    border-right: 1px solid #ccc;
}
.christmas-bullets-item1 .row-icon {
    background: url('../assets/gifts/vat.png') no-repeat center;
    background-size: contain;
}
.christmas-bullets-item2 .row-icon {
    background: url('../assets/gifts/delivery.png') no-repeat center;
    background-size: contain;
}
.christmas-bullets-item3 .row-icon {
    background: url('../assets/gifts/eu.png') no-repeat center;
    background-size: contain;
}

/* START Top Collections */
.home-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #002840;
    margin-bottom: 24px;
    position: relative;
    text-align: center;
}

/* END Top Collections */

#more-collections {
    background: #ebebeb url('../assets/gifts/snowflakes.png') no-repeat center bottom;
    background-size: cover;
}

@media(max-width: 767px) {
    .home-title {
        font-size: 20px;
        line-height: 24px;
    }
    .main-title {
        padding-top: 44px;
        font-size: 18px;
        line-height: 22px;
    }
    .main-subtitle {
        font-size: 16px;
        line-height: 20px;
        padding: 0 16px;
    }
    .home-tab-container .home-title {
        margin-top: 24px;
    }
    .home-tab-container .mobile-more-collections-wrapper .home-title {
        margin-top: 0;
    }
    .padding200 {
        padding-left: 16px;
        padding-right: 16px;
    }
    .padding80 {
        padding-top: 32px;
        padding-bottom: 32px;
    }
    .title-border {
        margin-bottom: 24px;
    }
    .christmas-wrapper, .christmas-title {
        height: auto;
    }
    .christmas-wrapper {
        padding: 12px;
    }
    .christmas-bullets-item .row-icon {
        height: 45px;
        width: 45px;
    }
    .christmas-bullets-item1,
    .christmas-bullets-item2 {
        padding-right: 6px;
    }
}
</style>
<style>
.collections-page .v-main {
    padding-top: 80px !important;
}
.christmas-page.collections-page ul.vindome-breadcrumbs {
    position: relative;
    background: #00304D;
    height: 24px;
    top: 0;
    left: 0;
    padding-left: 24px;
    padding-top: 6px;
    z-index: 9;
}
</style>
